import z from 'zod'

export const targetTypeSchema = z.union([
  z.literal('CATEGORY'),
  z.literal('ITEM'),
  z.literal('PAYMENT_WORKFLOW'),
])
export const approvalTypeSchema = z.union([
  z.literal('ACE_ADMIN'),
  z.literal('Family'),
])

export const statusFilterSchema = z.union([
  z.literal('All'),
  z.literal('active'),
  z.literal('inactive'),
])

export const ApprovalRuleSchema = z.object({
  id: z.number(),
  is_active: z.boolean(),
  name: z.string(),
  priority: z.number(),
  approval_type_id: z.number(),
  approval_type_code: z.string(),
  target_id: z.number(),
  target_name: z.string().optional(),
  description: z.string(),
  rule_target_type_id: z.number(),
  last_applied_at: z.string().nullable(),
  usage_count: z.number(),
  target_type_code: targetTypeSchema,
  conditions: z.null().or(z.unknown()), // or z.any() if you prefer
  created_by: z
    .object({
      id: z.number(),
      full_name: z.string(),
    })
    .optional(),
  created_datetime: z.string().optional(),
})

export const ApprovalRuleSchemaPayload = z.object({
  program_id: z.number(),
  approval_type: z.string(),
  target_type: z.string(),
  target_id: z.string(),
  name: z.string(),
  description: z.string(),
  is_active: z.boolean(),
})
export const RuleTargetTypeSchema = z.object({
  id: z.number(),
  name: targetTypeSchema,
})

export const ApprovalTypeSchema = z.object({
  id: z.number(),
  name: approvalTypeSchema,
})

export const GlobalPaymentTypeSchema = z.object({
  id: z.number(),
  name: z.string(),
})

// Pagination schemas
export const PaginationLinkSchema = z.object({
  url: z.string().nullable(),
  label: z.string(),
  active: z.boolean(),
})

export const PaginationMetaSchema = z.object({
  current_page: z.number(),
  from: z.number().nullable(),
  last_page: z.number(),
  links: z.array(PaginationLinkSchema),
  path: z.string(),
  per_page: z.number(),
  to: z.number().nullable(),
  total: z.number(),
})

export const PaginationLinksSchema = z.object({
  first: z.string(),
  last: z.string(),
  prev: z.string().nullable(),
  next: z.string().nullable(),
})

export const PaginatedApprovalRulesResponseSchema = z.object({
  data: z.array(ApprovalRuleSchema),
  links: PaginationLinksSchema,
  meta: PaginationMetaSchema,
})

export type RuleConfigOptions = {
  id: number
  name: string
}

export const PaymentRulesConfig = z.object({
  rule_target_types: z.array(RuleTargetTypeSchema),
  approval_types: z.array(ApprovalTypeSchema),
  global_payment_types: z.array(GlobalPaymentTypeSchema),
})

export const RulesUsageSchema = z.object({
  id: z.number(),
  rule_name: z.string(),
  rule_target_type: z.string(),
  rule_target_id: z.number(),
  payment_id: z.number(),
  payment_type_code: z.string(),
  payment_type: z.string(),
  payment_status_code: z.string(),
  payment_status: z.string(),
  evaluated_at: z.string(),
})

export const RulesUsageArraySchema = z.array(RulesUsageSchema)

export type PaymentRule = z.infer<typeof RulesUsageSchema>
export type RulesUsageArray = z.infer<typeof RulesUsageArraySchema>
export type RuleTargetType = z.infer<typeof RuleTargetTypeSchema>

export type ApprovalRulePayload = z.infer<typeof ApprovalRuleSchemaPayload>
export type TargetType = z.infer<typeof targetTypeSchema>
export type ApprovalType = z.infer<typeof approvalTypeSchema>
export type ApprovalRule = z.infer<typeof ApprovalRuleSchema>
export type PaymentRulesConfig = z.infer<typeof PaymentRulesConfig>
export type PaginatedApprovalRulesResponse = z.infer<
  typeof PaginatedApprovalRulesResponseSchema
>
export type PaginationMeta = z.infer<typeof PaginationMetaSchema>
export type PaginationLinks = z.infer<typeof PaginationLinksSchema>
